module.exports = __webpack_public_path__ + "img/event-2.59eb519c.png";